import { render, staticRenderFns } from "./CompilaQuestionarioScored.vue?vue&type=template&id=017f91f8&"
import script from "./CompilaQuestionarioScored.vue?vue&type=script&lang=js&"
export * from "./CompilaQuestionarioScored.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports